// taxe-api.js — LOT TAXE 0.4 (commit D) — appels admin barèmes taxe de séjour.
//
// Actions routées par /api/beds24-mapping (TOUTES requireAdmin — cf.
// lib/taxe-sejour-handlers.js). Pattern authHeaders calqué sur
// src/lib/cancellation-policies-api.js (Bearer session admin).

import { supabase } from "../supabase";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  return {
    Authorization: `Bearer ${session?.access_token || ""}`,
    "Content-Type": "application/json",
  };
}

async function postAction(action, body, fallbackError) {
  const res = await fetch(`/api/beds24-mapping?action=${action}`, {
    method: "POST",
    headers: await authHeaders(),
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json?.error || fallbackError);
  return json;
}

/**
 * Email de l'admin connecté, pour SIGNER un barème posé (saisi_par) —
 * affichage seulement, jamais une preuve d'identité (le serveur signe le
 * catalogue lui-même via req.user). null si pas de session.
 */
export async function emailSessionCourante() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  return (session && session.user && session.user.email) || null;
}

/**
 * Détection catalogue-d'abord (nom normalisé Q5 + CP en confirmation), sinon
 * proposition externe DELTA (Q7 : taux BRUT + avertissement + lien source).
 * @returns {Promise<{ok:true, match:'valide'|'propose'|'externe'|'none', bareme?, proposition?, avertissement?}>}
 */
export async function detectTaxeBareme({ commune, code_postal }) {
  return postAction(
    "taxe_bareme_detect",
    { commune, code_postal },
    "Détection du barème échouée",
  );
}

/**
 * SEUL point d'écriture catalogue (clic Dimitri — Q7 « jamais d'écriture
 * sans clic »). body : { id? } OU { commune_nom, code_postal, epci?,
 * taux_pct, plafond_eur, mineurs_exoneres?, source_url? }.
 */
export async function validateTaxeBareme(body) {
  return postAction("taxe_bareme_validate", body, "Validation du barème échouée");
}

/** Liste catalogue + dead-man Q6 (`last_reminder_at` max). */
export async function fetchTaxeCatalogue() {
  return postAction("taxe_catalogue_list", {}, "Lecture du catalogue échouée");
}

/** Bouton « Envoyer le rappel maintenant » (même logique que le cron Q6). */
export async function sendTaxeReminderNow() {
  return postAction("taxe_reminder_send", {}, "Envoi du rappel échoué");
}

/**
 * ADR-280 — crosscheck LECTURE SEULE du barème vs taxe COLLECTÉE par Booking
 * (v1 sans état : calcul à la demande au clic admin, aucune écriture, réponse
 * sans PII). `bareme` = barème consulté (resumeBareme) ou candidat (Detector).
 * @returns {Promise<{ok:true, bareme_used, verdict_global, stats, resas}>}
 */
export async function crosscheckTaxeBareme({ logement_id, bareme }) {
  return postAction(
    "taxe_bareme_crosscheck",
    { logement_id, bareme },
    "Vérification Booking échouée",
  );
}
